module.exports = __webpack_public_path__ + "img/erik-mclean-sirUHp_wdgM-unsplash.018234df.jpg";